<template>
  <div class="tab-pane fade" :class="{active: active }">
    <slot/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      in: false,
    };
  },
  computed: {
    active: {
      get() {
        const isActive = this.$parent.current === this;

        this.$nextTick(function () {
          this.in = isActive;
        });

        return isActive;
      },
      set(active) {
        return active
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.$parent.registerTab(this);
  }
}
</script>